export default __webpack_public_path__ + "static/media/IkonNounPeople.0eb7de30.svg";